import { Badge, Button, Divider, HStack, Stack, Td, Text, Tr } from "@chakra-ui/react";
import { Label, Show, Table, Tag } from "components";
import { Mask } from "config";

export default function Shipping({ order, ...props }){

    const columns = [{ children: 'Rótulo' }, { children: 'Altura', isNumeric: true }, { children: 'Largura', isNumeric: true }, { children: 'Comprimento', isNumeric: true }, { children: 'Peso', isNumeric: true }]

    return(
    <>
    <Stack spacing={6}>

        <HStack spacing={8}>
            <Label label="Cidade:" children={`${order.data?.city?.name}, ${order.data?.city?.state_code}`} />
            <Label label="CEP:" children={order.data?.address_zip} />
            <Label label="Endereço:" children={`${order.data?.address_line_1} ${order.data?.address_complement} ${order.data?.address_neighborhood}`} />
        </HStack>

        <HStack spacing={8}>
            <Label label="Valor da entrega:" children={`R$ ${Mask.price(order.data?.shipping_amount)}`} fontWeight="bold" fontSize="lg" />
            <Label label="Transportadora:" children={order.data?.shipment?.label} />
            <Label label="Código de rastreio:" children={order.data?.shipping_track_code} />
        </HStack>

        <Show visible={order.data?.volumes?.length >= 1}>
            <Divider />
            <Text size="sm" color="GrayText" children="Volumes:" />

            <Table size="sm" variant="striped" columns={columns}>
                { order.data?.volumes?.map((item, index) => (
                    <Tr key={item.id}>
                        <Td><Badge>Volume 0{index+1}</Badge></Td>
                        <Td isNumeric><Tag children={`${item.width} cm`} /></Td>
                        <Td isNumeric><Tag children={`${item.height} cm`} /></Td>
                        <Td isNumeric><Tag children={`${item.length} cm`} /></Td>
                        <Td isNumeric><Tag children={`${item.weight} kg`} /></Td>
                    </Tr>
                )) }
            </Table>
        </Show>
    </Stack>
    </>
    )
}